<script>
/**
 * Advanced table component
 */
export default {
  name: "CampaignLogChart",
  props: {
    campaignId: {
      type: [Number, String],
      default: null,
    },
    title: {
      type: String,
      default: " نمودار تحلیلی کمپین",
    },
  },
  data() {
    return {
      filterDays: 1,
      filterPeriod: "روزانه",
      date: "week",
      series: [
        {
          name: "شروع نمایش",
          data: [],
        },
        {
          name: "پایان نمایش",
          data: [],
        },
        {
          name: "کلیک",
          data: [],
        },
        {
          name: "نصب",
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: "area",
          zoom: {
            enabled: false,
          },
          animations: {
            enabled: true,
            easing: "linear",
            dynamicAnimation: {
              speed: 1000,
            },
          },
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        colors: [
          "#f63e3e",
          "#eeb902",
          "#1cbb8c",
          "#5664d2",
          "#03d3fc",
          "#fc6f03",
          "#b2c8d9",
          "#c969be",
          "#03ffc4",
        ],
        xaxis: {
          categories: [],
        },
      },
    };
  },
  mounted() {
    this.fetchChartData();
  },
  methods: {
    fetchChartData() {
      let route = `campaigns/logs/chart/group-by-date?period=${this.date}`;
      if (this.campaignId) {
        route = `campaigns/${this.campaignId}/logs/chart/group-by-date?period=${this.date}`;
      }
      this.$axios.get(route).then((res) => {
        this.chartOptions = {
          ...this.chartOptions,
          ...{
            xaxis: {
              categories: res.data.labels,
            },
          },
        };
        this.series[0].data = res.data.data.startShow;
        this.series[1].data = res.data.data.endShow;
        this.series[2].data = res.data.data.click;
        this.series[3].data = res.data.data.install;
        this.$refs.realtimeChart.updateSeries(this.series, false, true);
      });
    },
    fet() {
      this.$axios.get(`campaigns/${this.campaignId}/total-data`).then((res) => {
        console.log(res);
      });
    },
  },
};
</script>

<template>
  <div class="card">
    <div class="card-body">
      <div class="row mx-auto justify-content-between align-items-center">
        <h4 class="card-title mb-12">
          {{ title }}
        </h4>
        <div class="d-flex">
          <div class="mr-4">
            <label>دوره زمانی</label>
            <select
              @change="fetchChartData"
              v-model="date"
              class="form-control"
            >
              <option value="week">هفته جاری</option>
              <option value="month">ماه جاری</option>
              <option value="three_month">سه ماه گذشته</option>
              <option value="six_month">6 ماه گذشته</option>
              <option value="year">سال گذشته</option>
            </select>
          </div>
        </div>
      </div>
      <div>
        <div class="apex-charts" dir="rtl"></div>
        <apexchart
          class="apex-charts"
          dir="rtl"
          ref="realtimeChart"
          :series="series"
          :options="chartOptions"
          type="line"
          height="350"
        ></apexchart>
      </div>
    </div>
  </div>
</template>
